import { create } from 'zustand';
import { eventData } from '../utils/constants';
import type { Filters } from '../types/FiltersSchema';
import type { ParsedAnalyticsSchema } from '../types/AnalyticsSchema';

interface FilterStoreState {
  filters: Filters;
  searchValue: string;
  data: ParsedAnalyticsSchema[];
}

interface FilterStoreActions extends FilterStoreState {
  setFilters: (filters: Filters) => void;
  setSearchValue: (value: string) => void;
  setData: (data: ParsedAnalyticsSchema[]) => void;
  clearFilters: () => void;
}
const initialFilters = {
  filters: {
    domain: '',
    event_name: '',
    product_area: '',
    search: '',
  },
  searchValue: '',
  data: eventData,
};

export const useFilterStore = create<FilterStoreState & FilterStoreActions>(
  (set) => ({
    filters: initialFilters.filters,
    setFilters: (filters) => set({ filters }),
    searchValue: '',
    setSearchValue: (searchValue) => set({ searchValue }),
    data: initialFilters.data,
    setData: (data) => set({ data }),
    clearFilters: () => set(initialFilters),
  }),
);
